import { initializeApp, getApps } from 'firebase/app';

// Firebase config — environment-driven with DEV fallbacks.
// `npm run build:dev` injects dev (fodyfee-affcc) values from .env.dev;
// `npm run build:prod` injects prod (fodyfee-prod) values from .env.prod.
// With no env vars present (local dev server), the hardcoded DEV values
// below keep everything working exactly as before.
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAnBY2pCJYI8n_6BmlVZIGsrCAWGQ3c2W0',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'fodyfee-affcc.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'fodyfee-affcc',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'fodyfee-affcc.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '659841746443',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:659841746443:web:f094d2c54f64f8f01f290e',
};

// Initialize the default Firebase app as soon as this module is first
// imported, instead of relying on whichever page component happens to call
// initializeApp()/getAuth()/getFirestore()/getFunctions() first in the
// bundle's module evaluation order. Several files (e.g. FodyFlightPage.js)
// call getFunctions()/getFirestore()/getAuth() at module top level — that
// code runs the instant the bundle loads, on every route, regardless of
// which page is actually being rendered. If nothing had initialized the
// default app yet by that point, those calls threw
// "No Firebase App '[DEFAULT]' has been created" and crashed the entire
// React render with no error boundary, showing a blank page — this is what
// happened on /stripe/return, which (being a fresh full-page load from an
// external redirect) evaluates the whole bundle from scratch every time.
// This import has no side effects of its own beyond guaranteeing the app
// exists — it's intentionally imported first in App.js.
if (!getApps().length) {
  initializeApp(firebaseConfig);
}